module.exports = __webpack_public_path__ + "static/physicist-2f7c042db9010caf8e4b2eaaf8574af7.jpeg";